export enum Division {
  tns = 'TNS',
  sng = 'SNG',
  roi = 'ROI',
  ni = 'NI',
  notDefined = '',
}

export enum Company {
  tns = 'TNS',
  sng = 'SNG',
}

export type CurrencyCode = 'EUR' | 'GBP';

export enum LocalStorageKeysEnum {
  reRouteAfterLogIn = 're-route-path-after-log-in',
}
